import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/** @deprecated - DndRoot is included in root App structure, you don't need to render it yourself. */
export const TokenRoot = ({ children }) => (_jsx(_Fragment, { children: children }));
//# sourceMappingURL=TokenRoot.js.map